import { Button } from '@rbilabs/universal-components';

import { primitive, spacing } from 'styles/constants';
export const RedeemButton = Button.withConfig({
  variant: 'solid',
  backgroundColor: primitive.$meltyYellow,
  textDecorationColor: primitive.$meltyYellow,
  _hover: {
    backgroundColor: primitive.$meltyYellowDark45,
  },
  _pressed: {
    backgroundColor: primitive.$meltyYellowDark40,
  },

  height: spacing.$7,
  size: 'sm',
  _text: {
    variant: 'copyTwo',
    fontSize: 'xs',
    lineHeight: 'xs',
    color: primitive.$bbqBrown,
  },
});
